import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Jckla { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '序號 (LA001) 不可空白'}) 
    @MaxLength(10,{message: '序號 (LA001) 資料太長'})
    LA001: string = '';            // 序號 10 [int] IDENTITY(1, 1)


    LA002: Date | undefined;            // 時間 0 

    @MaxLength(255,{message: '路徑URL (LA003) 資料太長'})
    LA003: string = '';            // 路徑URL 255 

    @MaxLength(255,{message: 'QueryFields (LA004) 資料太長'})
    LA004: string = '';            // QueryFields 255 

    LA005: string = '';            // RequestContent 0 

    LA006: string = '';            // ResponseContent 0 

    @MaxLength(255,{message: '備註 (LA007) 資料太長'})
    LA007: string = '';            // 備註 255 


}
